import { ModulePlaceholderList } from '../../components/ModulePlaceholderList';

export default function AllOnboardings() {
  return (
    <ModulePlaceholderList
      title="Onboardings"
      newPath="/panel/onboardings/new"
      newLabel="New onboarding"
    />
  );
}
